module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-new_dot_2.png?v=eed98bd7";